import {login} from './login'
import {loginPhone} from './loginPhone'
import {googleLogin} from './googleLogin'
import { fbLogin } from './facebookLogin'
import { logout } from './logOut'

export const generateId = _ => {
    const s4 = _ => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
}

export const logIn = (creds) => { return login(creds,generateId) }


export const LogInMobile = (creds) => { return loginPhone(creds,generateId)}

export const VerifyMobile = (creds) => {return loginPhone(creds,generateId,"validate")}

export const verifyEmail = (creds) => {return login(creds,generateId,"validate")}

export  const logInGoogle = (userRes, isCheckoutScreen) => { return googleLogin(userRes,generateId, isCheckoutScreen)}


export  const logWithFb = (userRes) => { return fbLogin(userRes,generateId)}

export const LogOut = () => { return logout()}
